import Dashboard from "./Dashboard";

function Main() {
  return <Dashboard />;
}

export default Main;
